import { render, staticRenderFns } from "./OutBoundTagPrint.vue?vue&type=template&id=a8b18144"
import script from "./OutBoundTagPrint.vue?vue&type=script&lang=js"
export * from "./OutBoundTagPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports